import { Accordion, AccordionDetails, AccordionSummary, Skeleton } from '@mui/material';
import { memo } from 'react';
import { ItemCardSkeleton } from '../../../../common/instances/components/skeletons/ItemCardSkeleton';

type Props = {
  open: boolean;
};

export const IssueGroupSkeleton = memo(({ open }: Props) => {
  return (
    <Accordion expanded={open}>
      <AccordionSummary expandIcon={<></>} sx={{ minHeight: '4rem' }}>
        <Skeleton height={32} width={50} />
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        {open &&
          Array(5)
            .fill('')
            .map((_, index) => (
              <ItemCardSkeleton key={index}>
                <Skeleton height={24} width="80%" />
                <Skeleton height={20} width="100%" />
                <Skeleton height={20} width="40%" />
              </ItemCardSkeleton>
            ))}
      </AccordionDetails>
    </Accordion>
  );
});
